<template>
  <div v-if="canShowBadge">
    <div :class="noButton ? '' : 'sub-wrapper'">
      <ModeIcon :mode="subscription.mode">{{subscription.price}}$ / month</ModeIcon>

      <button 
        :class="actionButtonClass" 
        @click="doAction" 
        v-if="!noButton">{{ actionButtonTitle }}</button>
    </div>
    <small class="status-flag" v-if="subscription.mode == 'pro'">
      INSIDE + TAKEAWAY + DELIVERY + RESERVE 
    </small>
    <small
      :class="{
        'status-flag': true,
    }"
      v-if="subscriptionStatus == 'inactive'"
    >{{ $t('subscription.inactive') }}</small>
    <small
      :class="{
        'status-flag': true,
        'trial': true
    }"
      v-if="subscriptionStatus == 'trial'"
    >{{ $t('subscription.trial_period_until') }} {{ subscription.trial_period_until | formatDate }}</small>
    <small
      :class="{
        'status-flag': true,
        'active': true
    }"
      v-if="subscriptionStatus == 'active' && subscription.liqpay_id"
    >{{ $t('subscription.active_until') }} {{ subscription.paid_until | formatDate }}</small>
    <small
      :class="{
        'status-flag': true,
        'active': true
    }"
      v-if="subscriptionStatus == 'active' && !subscription.liqpay_id"
    >{{ $t('subscription.paid_until') }} {{ subscription.paid_until | formatDate }}</small>
    <small
      :class="{
        'status-flag': true,
        'end': true
    }"
      v-if="subscriptionStatus == 'ended'"
    >{{ $t('subscription.ended') }} {{ subscription.paid_until | formatDate }}</small>

    <form
      method="POST"
      action="https://www.liqpay.ua/api/3/checkout"
      accept-charset="utf-8"
      ref="subscribeForm"
      v-if="subscribe_form"
    >
      <input type="hidden" name="data" :value="subscribe_form.data" />
      <input type="hidden" name="signature" :value="subscribe_form.signature" />
    </form>

    <ConfirmModal
      @confirm="cancelSubscription"
      @cancel="cancel_modal = false"
      v-if="cancel_modal"
    >{{$t('subscription.cancel')}}</ConfirmModal>
  </div>
</template>

<script>
import ModeIcon from "@/components/ModeIcon.vue";
import ConfirmModal from "@/components/modals/ConfirmModal.vue";
import moment from "moment";

import SubscriptionAPI from "@/api/subscription";

export default {
  components: {
    ModeIcon,
    ConfirmModal
  },
  data() {
    return {
      subscribe_form: null,
      cancel_modal: false,

      button_hover: false
    };
  },
  props: {
    subscription: Object,
    noButton: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    openSubscribeForm() {
      SubscriptionAPI.generateForm(this.subscription._id)
        .then(data => {
          this.subscribe_form = data.form;

          this.$nextTick(() => {
            this.$refs.subscribeForm.submit();
          });
        })
        .catch(error => {
          this.$store.dispatch("showError", "subscription_error");
        });
    },
    doAction() {
      if (!this.canPaySubscription) {
        this.$store.dispatch('showError', 'subscription_setup_mode');
        return;
      }

      if (!this.subscription.liqpay_id) {
        this.openSubscribeForm();
      } else {
        this.showCancelUI();
      }
    },
    showCancelUI() {
      this.cancel_modal = true;
    },
    cancelSubscription() {
      this.cancel_modal = false;

      SubscriptionAPI.cancelSubscription(this.subscription._id)
        .then(data => {
          this.$store.commit("subscriptions/setSingleSubscription", {
            mode: this.subscription.mode,
            subscription: data.subscription
          });
        })
        .catch(error => {
          this.$store.dispatch("showError", "subscription_error");
        });
    }
  },
  computed: {
    cafe() {
      return this.$store.state.cafe;
    },
    canShowBadge() {
      if (this.subscription.mode == 'hotels' && !this.$store.getters.isHotel) return false;

      if (!this.noButton) return true;

      if (this.subscriptionStatus != 'active' && this.subscriptionStatus != 'trial') return false;

      return true;
    },
    subscriptionStatus() {
      if (!this.subscription.paid_until) return "inactive";

      const now = moment();
      const then = moment(this.subscription.paid_until);

      const is_active = now.isBefore(then);

      if (this.subscription.trial_period_until) {
        const trial_moment = moment(this.subscription.trial_period_until);

        if (now.isBefore(trial_moment) && trial_moment.isSameOrAfter(this.subscription.paid_until)) return 'trial';
      }

      return is_active ? "active" : "ended";
    },
    actionButtonClass() {
      return {
        "badge-button": true,
        "badge-button-red": !!this.subscription.liqpay_id,
        "badge-button-green": !this.subscription.liqpay_id,
        "badge-button-disabled": !this.canPaySubscription
      };
    },
    actionButtonTitle() {
      if (this.subscription.liqpay_id) {
        return this.$t('subscription.cancl');
      }

      // if (this.subscriptionStatus == "active") return this.$t('subscription.cancl');
      if (this.subscriptionStatus == "ended") return this.$t('subscription.renew');
      if (this.subscriptionStatus == "inactive") return this.$t('subscription.subscribe');

      return this.$t('subscription.subscribe');
    },
    canPaySubscription() {
      if (this.subscription.mode == 'pro') return true;

      if (this.subscription.liqpay_id || this.subscription.paid_until) {
        return true;
      }

      if ((this.subscription.mode == 'inside' || this.subscription.mode == 'inside_lite') && !this.cafe.activated) {
        return false;
      }

      if (this.subscription.mode == 'inside_lite') {
        return this.$store.getters[`readyInsideLite`].subtotal;
      }  

      //a little reflecation hack to avoid if's for each mode

      //'delivery' => 'Delivery' => 'readyDelivery' getter
      const getter_name = this.subscription.mode.substring(0,1).toUpperCase() + this.subscription.mode.substring(1);

      return this.$store.getters[`ready${getter_name}`].subtotal;
    }
  }
};
</script>

<style scoped>
.sub-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.pt-3:first-child {
  padding-top: 0 !important;
}

small.status-flag {
  color: #908f8d;
  font-size: 1.5vh;
  display: block;
  line-height: normal;
  padding: 0.5vh 0 0;
}

small.status-flag.active {
  color: #129b81;
}

small.status-flag.end {
  color: #e2223b;
}

small.status-flag.trial {
  /* color: #129b81; */
  color: #FF6F00;
}

.badge-button {
  outline: none;
  border: 1px solid #464646;
  -webkit-appearance: none;
  background: transparent;
  font-size: 1.8vh;
  border-radius: 0.6vh;
  padding: 0.1vh 3vh;
  cursor: pointer;
  float: right;
}

.badge-button-red {
  color: #e2223b;
  border: 2px solid #e2223b;
}

.badge-button-green {
  color: #129b81;
  border: 2px solid #129b81;
}

.badge-button-disabled {
  border: 2px solid #464646;
  color: #464646;
}

.cant-pay-text {
  color: #ededed;
  background: #464646;
  position: absolute;
  padding: 2vh;
  z-index: 10;
}

.badge-button:hover {
  background: #129b81;
  color: #ededed;
  border: 2px solid #129b81;
}
</style>